import React from "react";
import { useAnimatedPlaceholder } from "../hooks/animated_placeholder";
import { CloseIcon, SearchIcon, SubmitIcon } from "../icons";
import { useDialogState } from "../providers/dialog_state_provider";
import { useSearchQuery } from "../providers/search_query_provider";

export default function SearchBar() {
  const { query, setQuery, triggerQuerySubmit } = useSearchQuery();
  const { closeDialog } = useDialogState();
  const animatedPlaceholder = useAnimatedPlaceholder(query);

  return (
    <div className="dewey--search--bar--container">
      <div className="dewey--search--bar">
        <div className="dewey--search--bar-bg" />
        <SearchIcon className="dewey--search--bar--icon" />
        <input
          type="text"
          className="dewey--search--bar--input"
          placeholder={animatedPlaceholder}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              triggerQuerySubmit();
              if (e.target instanceof HTMLInputElement) {
                e.target.blur();
              }
            }
          }}
          autoFocus
        />

        <button
          type="button"
          className="dewey--search--bar--submit"
          onClick={triggerQuerySubmit}
        >
          <SubmitIcon />
        </button>
      </div>
      <button
        type="button"
        className="dewey--search--bar--close"
        onClick={closeDialog}
      >
        <CloseIcon />
      </button>
    </div>
  );
}
